import{a as r,b as o}from"./tslib.es6-ee78b631.js";import e from"react";import{P as t}from"./index-60f2dc56.js";var c=function(c){var i=c.color,a=void 0===i?"grey-8":i,l=c.children,m=r(c,["color","children"]);return e.createElement(t,o({},m,{color:a}),l)};export{c as P};
//# sourceMappingURL=Paragraph-8fd9b17a.js.map
